import { useParams, Navigate } from 'react-router-dom';

import { MessageUpdate } from './components/message-update';

import { routeCreator } from '../triggered-messages.utils';

export const TriggeredMessageEdit = () => {
  const { messageId, scope } = useParams<{ messageId?: string; scope?: string }>();

  if (!messageId) {
    return <Navigate to={routeCreator.base.to()} replace />;
  }

  return <MessageUpdate messageId={messageId} scope={scope} />;
};
